import { render, staticRenderFns } from "./instagramTV.vue?vue&type=template&id=281bb48f&"
import script from "./instagramTV.vue?vue&type=script&lang=js&"
export * from "./instagramTV.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports